import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'loneliness_frequency'

const OPTIONS = [
  {
    value: 'rarely',
    translationKey: 'pages.onboarding.lonelinessFrequency.options.rarely',
  },
  {
    value: 'sometimes',
    translationKey: 'pages.onboarding.lonelinessFrequency.options.sometimes',
  },
  {
    value: 'often',
    translationKey: 'pages.onboarding.lonelinessFrequency.options.often',
  },
  {
    value: 'daily',
    translationKey: 'pages.onboarding.lonelinessFrequency.options.daily',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '🙂',
    title: 'pages.onboarding.lonelinessFrequency.options.rarely',
    value: 'rarely',
  },
  {
    emoji: '🤷',
    title: 'pages.onboarding.lonelinessFrequency.options.sometimes',
    value: 'sometimes',
  },
  {
    emoji: '😕',
    title: 'pages.onboarding.lonelinessFrequency.options.often',
    value: 'often',
  },
  {
    emoji: '😔',
    title: 'pages.onboarding.lonelinessFrequency.options.daily',
    value: 'daily',
  },
]

export default function LonelinessFrequencyPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How often do you feel lonely?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.lonelinessFrequency.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
